

export function getTabFromQuery(props: any, tabFeatureLibrary: string[]) {
    // handle the page request case
    const currentPath = props.location.pathname + props.location.search;

    if (props !== undefined && props.location.pathname !== undefined) {
        try {
            return tabFeatureLibrary[parseInt(props.location.search.split("=")[1])];
        }
        catch(e) {
            return undefined;
        }
    }

    // if the page request isn't present check for a parented router context
    if (props === undefined || currentPath === undefined) return undefined;
    if (currentPath === undefined) return undefined;

    // const tabQuery = this.props.location.search.t;

    // if (tabQuery === undefined) return undefined;

    // try {
    //     return tabFeatureLibrary[parseInt(tabQuery)];
    // }
    // catch(e) {
    //     return undefined;
    // }
}
